// import AppConstants from "../components/AppConstants";

// let authToken = localStorage.getItem(AppConstants.JWT);

// const config = {
//     headers: {Authorization: `Token ${authToken}`}
//   };
//   console.log("Config:", config);
// export default config;


import AppConstants from "../components/AppConstants";


export const getConfig = () => {
  const authToken = localStorage.getItem(AppConstants.JWT)
  return{ headers: {Authorization: `Token ${authToken}`,
  'Content-Type': 'application/json',
}}
}

